import React, { useLayoutEffect, useRef } from 'react';
import {
  resettableParams,
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import { useAcceptanceViewFlatsIsFetching } from '../../../../api/acceptanceViewFlats';
import { useAcceptanceViewCalendarIsFetching } from '../../../../api/acceptanceViewCalendar';

export const useDeferredResetStateOnAcceptanceChange = () => {
  const { setParams } = useSearchParamsMethods();

  const acceptanceSlug = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.acceptance]
  );

  const prevSlugRef = useRef(acceptanceSlug);
  const needResetRef = useRef(false);

  if (prevSlugRef.current !== acceptanceSlug) {
    needResetRef.current = true;
    prevSlugRef.current = acceptanceSlug;
  }

  const isRoomsFetching = useAcceptanceViewFlatsIsFetching();
  const isCalendarFetching = useAcceptanceViewCalendarIsFetching();

  useLayoutEffect(() => {
    if (needResetRef.current && !isRoomsFetching && !isCalendarFetching) {
      needResetRef.current = false;
      setParams(resettableParams);
    }
  }, [acceptanceSlug, isRoomsFetching, isCalendarFetching, setParams]);
};

export const withDeferredResetStateOnAcceptanceChange = (Component) => {
  return (props) => {
    useDeferredResetStateOnAcceptanceChange();

    return <Component {...props} />;
  };
};

export const DeferredResetStateOnAcceptanceChangeWrapper = ({ children }) => {
  useDeferredResetStateOnAcceptanceChange();

  return children;
};
